/**
 * Patient site runtime configuration.
 *
 * Every value comes from the stage being built. Nothing is configured here: to change a value, edit that
 * stage's own file under `environments/` at the repository root - `stage.ts` (local), `stage.test.ts` or
 * `stage.production.ts`, shared with the partner portal since both apps talk to the same API.
 * `stage.model.ts` is the shape all three implement; STANDARDS.md "Build stages" explains the swap.
 */
import { STAGE } from '../../../../environments/stage';

export const environment = {
  /** Which stage this build is: 'local', 'test' or 'production'. */
  STAGE: STAGE.name,
  /** Angular production mode: on for every deployed stage, off while developing locally. */
  production: STAGE.production,
  /** Partner Platform API root. Every path in this app is relative to it, e.g. api/membership/plans. */
  BASE_URL: STAGE.BASE_URL,
  /** Where uploaded pictures live (the platform's file storage address replaces this once settings load). */
  IMAGE_BASE_URL: STAGE.IMAGE_BASE_URL,
  /** How long the OTP resend button stays disabled, in seconds, until the server says otherwise. */
  OTP_RESEND_SECONDS: STAGE.OTP_RESEND_SECONDS,
};
